import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { MenuItem } from '../models';
import { ODataResponse } from '../models/odata-response.model';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private http: HttpClient) { }

  getMenuItems(): Observable<MenuItem[]> {
    const endpoint = environment.endpoints?.baseApi;
    return this.http.get<ODataResponse<MenuItem[]>>(`${endpoint?.url || ''}odata/v2/MenuItems?$filter=isActive eq true`)
      .pipe(map(val => val.value || []));
  }
}
